<template>
	<c-dialog ref="dialog" width="800" height="560" enable-flex @resolve="submitHandle">
		<!-- 商品范围信息 -->
		<div class="m-offshelf-info flex">
			<template v-if="productList.length == 1">
				<p class="flex-grow ellipsis m-product-label">产品信息：<span class="m-product-name">{{productList[0].product_info || '-'}}</span></p>
				<p class="m-product-code">背贴码：{{productList[0].produce_unique_code || '-'}}</p>
			</template>
			<template v-else>
				<p class="flex-grow ellipsis m-product-label">已选商品：<span class="m-product-name">{{productList.length}}个</span></p>
			</template>
		</div>

		<!-- 可下架渠道列表 -->
		<div class="m-offshelf-table-area flex-column flex-grow">
			<c-table ref="list" :data="channelList" height="grow" :paging="false" empty-text="暂无可下架的渠道">
				<c-table-column type="selector" width="40"></c-table-column>
				<c-table-column label="下架渠道" name="channel_name" min-width="160"></c-table-column>
				<c-table-column label="渠道类型" width="100">
					<template #default="{data}">
						<span :class="data.is_dark_auction == 1 ? 'm-biz-dark' : 'm-biz-normal'">{{data.is_dark_auction == 1 ? '暗拍渠道' : '靓机渠道'}}</span>
					</template>
				</c-table-column>
				<c-table-column v-if="productList.length > 1" label="涉及商品" width="100">
					<template #default="{data}">{{data.product_count}}个</template>
				</c-table-column>
				<c-table-column label="当前状态" width="120">
					<template #default="{data}">
						<span v-if="data.has_on_sale" class="m-state-on">在售</span>
						<span v-else class="m-state-wait">待推送</span>
					</template>
				</c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'saleOffShelfChannel',

		data() {
			return {
				productList: [],
				channelList: []
			}
		},

		methods: {
			/*********打开弹框（支持单个/批量商品）**********/
			open(data) {
				this.productList = (data && data.list) || [];
				this.channelList = this.buildChannelList();
				this.$refs.dialog.open({
					title: this.productList.length > 1 ? '批量下架' : '选择下架渠道',
					buttonName: '确定下架'
				});
			},

			/*********聚合可下架渠道（按渠道维度并集，批量时统计涉及商品数）**********
			 * 可下架范围（与后端下架分流一致）：
			 * 1.在售渠道（排除同步中）；
			 * 2.暗拍待推送取消（暗拍+待同步+未在售的上架待推送记录）*/
			buildChannelList() {
				var channelMap = {};
				var order = [];
				this.productList.forEach(product => {
					(product.channel_list || []).forEach(channel => {
						/**同步中（推送中/审核中）渠道不可下架*/
						if (channel.sync_state == 2) return;
						var onSale = channel.listing_state == 2;
						/**暗拍在售即已进入竞拍，不可手动下架（由次日裁定自动收敛），不计入可下架范围*/
						if (channel.is_dark_auction == 1 && onSale) return;
						var darkWaitPush = channel.is_dark_auction == 1 && channel.sync_state == 1 && !onSale;
						if (!onSale && !darkWaitPush) return;
						var item = channelMap[channel.channel_id];
						if (!item) {
							item = {
								channel_id: channel.channel_id,
								channel_name: channel.channel_name,
								is_dark_auction: channel.is_dark_auction,
								product_count: 0,
								has_on_sale: false
							};
							channelMap[channel.channel_id] = item;
							order.push(channel.channel_id);
						}
						item.product_count++;
						if (onSale) item.has_on_sale = true;
					});
				});
				return order.map(channelId => channelMap[channelId]);
			},

			/*********提交下架**********/
			submitHandle(stop, next) {
				stop();
				var selectedList = this.$refs.list.getData('selected');
				if (!selectedList.length) {
					this.$message({message: '请至少勾选一个要下架的渠道', type: 'warn'});
					return;
				}
				this.request({
					url: '/sale/product/offShelf',
					data: {
						product_ids: this.productList.map(item => item.id),
						channel_id_list: selectedList.map(item => item.channel_id)
					},
					loading: true,
					success: (data, msg) => {
						next();
						this.$message({message: msg || '下架提交成功', type: 'success'});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	::v-deep .c-dialog-body {
		padding: 0 12px;
	}

	.m-offshelf-info {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;
		gap: 12px;

		.m-product-label {
			color: #333;
		}

		.m-product-name {
			color: #1890ff;
		}

		.m-product-code {
			color: #666;
		}
	}

	.m-offshelf-table-area {
		margin: 0 20px 10px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;

		::v-deep .c-table-body table tbody tr {
			&.is-selected {
				background-color: #fffbe6 !important;
			}
		}
	}

	.m-biz-dark {
		color: #722ed1;
	}
	.m-biz-normal {
		color: #fa8c16;
	}
	.m-state-on {
		color: #19be6b;
	}
	.m-state-wait {
		color: #e6a23c;
	}
</style>
